import { useCallback, useMemo } from 'react';

import { Button } from '@mui/material';
import { RiFileExcel2Fill } from 'react-icons/ri';

import { useListagemContext } from 'context/ListagemContext';
import { useDownloadFile } from 'hooks/useDownloadFile';
import { RequestOptionsType } from 'hooks/useRequestListagem';

interface RelatorioCreditosItemDetalhamentoCreditosProps {
    disabled: boolean;
}

export function RelatorioCreditosItemDetalhamentoCreditos({ disabled }: RelatorioCreditosItemDetalhamentoCreditosProps) {
    const { filter } = useListagemContext();

    const requestOptions: RequestOptionsType = useMemo(
        () => ({
            url: '/financeiro/detalhamentocreditodebitoprodutorelatorio/promocao',
            columns: 'idDetalhamentoCreditoDebito', // somente esta aqui por ser obrigatório no endpoint
            filter,
        }),
        [filter],
    );

    const { isLoadingFile, downloadFile } = useDownloadFile({
        requestOptions,
    });

    const handleClickDownload = useCallback((): void => {
        downloadFile({
            newRequestOptions: requestOptions,
            directDownload: true,
        });
    }, [downloadFile, requestOptions]);

    return (
        <Button
            loading={isLoadingFile}
            variant="outlined"
            color="success"
            onClick={handleClickDownload}
            disabled={disabled || isLoadingFile}
            startIcon={<RiFileExcel2Fill />}
        >
            Detalhamento Créditos por Item (totalizador)
        </Button>
    );
}
